<template>
  <div class="card_background">
  <el-card shadow="never" class="aui-card--fill">
    <div slot="header" class="clearfix">
      <span>微信公众号配置</span>
    </div>
    <div class="mod-wechat__mp">
      <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
               :label-width="'120px'">
        <el-form-item label="公众号名" prop="mpName">
          <el-input v-model="dataForm.mpName" placeholder="公众号名"></el-input>
        </el-form-item>
        <el-form-item label="公众号TOKEN" prop="mpToken">
          <el-input v-model="dataForm.mpToken" placeholder="公众号TOKEN"></el-input>
        </el-form-item>
        <el-form-item label="微信公众号" prop="mpNumber">
          <el-input v-model="dataForm.mpNumber" placeholder="微信公众号"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="mpEmail">
          <el-input v-model="dataForm.mpEmail" placeholder="微信公众号邮箱"></el-input>
        </el-form-item>
        <el-form-item label="APP_ID" prop="mpAppid">
          <el-input v-model="dataForm.mpAppid" placeholder="微信公众号APPID"></el-input>
        </el-form-item>
        <el-form-item label="原始ID" prop="mpOriginalId">
          <el-input v-model="dataForm.mpOriginalId" placeholder="公众号原始ID"></el-input>
        </el-form-item>
        <el-form-item label="APP_SECRET" prop="mpSecret">
          <el-input v-model="dataForm.mpSecret" placeholder="公众号APP_SECRET"></el-input>
        </el-form-item>
        <el-form-item label="EAS_KEY" prop="mpAesKey">
          <el-input v-model="dataForm.mpAesKey" placeholder="公众号EAS_KEY"></el-input>
        </el-form-item>
      </el-form>
      <div style="display: flex;justify-content: end">
        <el-button v-if="$hasPermission('wechat:mp:save')&&$hasPermission('wechat:mp:update')"
                   type="primary" @click="dataFormSubmitHandle()">
          {{dataForm.id?'修改':'保存'}}
        </el-button>
      </div>
    </div>
  </el-card>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      dataForm: {
        id: '',
        mpName: '',
        mpToken: '',
        mpNumber: '',
        mpEmail: '',
        mpAppid: '',
        mpOriginalId: '',
        mpSecret: '',
        mpAesKey: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        mpName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        mpToken: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        mpNumber: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        mpEmail: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        mpAppid: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        mpOriginalId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        mpSecret: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        mpAesKey: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        this.getInfo()
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get('/wechat/mp/getWeChatMp').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/wechat/mp/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {
        })
      })
    }, 1000, { leading: true, trailing: false })
  },
  created () {
    this.init()
  }
}
</script>
<style scoped>
.el-card, .el-message {
  border-radius: 4px;
  overflow: hidden;
  width: 50% !important;
  margin: 0 auto !important;
  min-width: 500px !important;
}
.card_background{
  background-color: #fff;
  width: 100%;
  padding: 50px;
  height: calc(calc(100vh - 50px - 50px - 20px))
}
</style>
